// extracted by mini-css-extract-plugin
export var numpadContainer = "_m1-1";
export var phoneButton = "_m1-0";